import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {ModalData} from "../../../shared-module/types/modal-data.type";
import {
  PhoneDetailsDisplayComponent
} from "../../../shared-module/components/phone-details-display/phone-details-display.component";
import {PhoneProduct} from "../../../shared-module/model/product.model";

@Component({
    selector: 'app-phone-details',
    imports: [
        PhoneDetailsDisplayComponent,
    ],
    templateUrl: './phone-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './phone-details.component.scss'
})
export class PhoneDetailsComponent {
  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Inject(ModalData) public phoneProduct: PhoneProduct) {}
}
